import React, { FC } from 'react'
import { ArticleProps } from './Article.types'
import {
  articleInnerConstrainedClasses,
  articleInnerVertPadding,
  setArticleIntroLayoutSize,
  setArticleLayoutSize,
} from './utils/setCssClasses'
import { Compounds } from '../Compounds'
import {
  setBgContrastClass,
  setConfigBgColorClass,
  setConfigVertSpacing,
} from '../../utils/layout-util'
import { RTECompound } from '../Compounds/src/RTECompound'
import './article.scss'

export const Article: FC<ArticleProps> = props => {
  const {
    title,
    description,
    contents,
    brandExtension,
    introduction,
    layoutConfigs,
    anchorIdentifier,
    dataAnalytics,
    displayName,
  } = props.content
  const backgroundColor = setConfigBgColorClass(layoutConfigs)
  const setBackgroundColor = backgroundColor
    ? `${backgroundColor} ${setBgContrastClass(layoutConfigs)} `
    : 'noBgColor'
  const contentAlignment = (align?: string) => {
    if (align == 'Right') {
      return 'u-flexJustifyEnd'
    } else if (align == 'Center') {
      return 'u-flexJustifyCenter'
    } else {
      return ''
    }
  }

  const articleContent = contents?.map(content => {
    return (
      <section className='Content' key={content.identifier}>
        {content?.anchorlinks?.sectionTitle && (
          <h2
            className={`${setArticleLayoutSize(
              layoutConfigs
            )} u-sm-sizeFull u-sm-marginLeft0" id="${content.anchorlinks.sectionAnchorlink}`}>
            {content.anchorlinks.sectionTitle}
          </h2>
        )}
        {content.blocks && (
          <div
            className={`${setArticleLayoutSize(
              layoutConfigs
            )} u-marginCenter u-sm-sizeFull u-sm-marginLeft0 ${
              content.alignment ? contentAlignment(content.alignment) + 'u-flex' : ''
            } ${
              content.divider && content.divider === 'true'
                ? 'divider u-marginBottom4gu u-paddingBottom2gu u-decoBorderLight u-decoBorderResetTop'
                : 'u-marginBottom5gu'
            }`}>
            <Compounds {...content.blocks} />
          </div>
        )}
      </section>
    )
  })

  return (
    <section
      className={`Article ${setConfigVertSpacing(layoutConfigs)} ${brandExtension}`}
      id={anchorIdentifier}
      data-analytics={dataAnalytics ?? 'article'}
      data-analytics-component-name='Article'
      data-analytics-content-document-name={displayName}>
      <div className={` ${setBackgroundColor} ${introduction?.content ? 'has-intro' : ''}`}>
        <div
          className={`${articleInnerConstrainedClasses(layoutConfigs)}  ${articleInnerVertPadding(
            layoutConfigs
          )}`}>
          <div className='u-posRelative'>
            <div
              className={`Content ${setArticleIntroLayoutSize(
                layoutConfigs
              )} u-sm-sizeFull u-sm-marginLeft0 u-sm-paddingHoriz4gu`}>
              {title && <h2 id={title}>{title}</h2>}

              {introduction?.content && (
                <div className='Content u-paddingBottom7gu'>
                  <RTECompound {...introduction} />
                </div>
              )}
            </div>
          </div>
          <div className={`Content u-sizeFull u-sm-paddingHoriz4gu u-posRelative`}>
            {description?.content && (
              <div
                className={`${setArticleLayoutSize(
                  layoutConfigs
                )} u-sm-sizeFull u-sm-marginLeft0 u-paddingBottom7gu u-marginCenter `}>
                <RTECompound {...description} />
              </div>
            )}
            {articleContent}
          </div>
        </div>
      </div>
    </section>
  )
}
